import { ChevronLeft, Home } from "lucide-react";
import { DemoBadge } from "../DemoPanels";

/**
 * Shared phone frame used by Demo Scenarios and other public product demos.
 * It is deliberately presentational: callers own all state and actions.
 */
export default function DeviceShell({ children, title, canBack, onBack, onHome }) {
  return (
    <div
      data-testid="device-shell"
      className="mx-auto rounded-[2rem] border-[6px] border-slate-900 bg-slate-900 shadow-xl w-full max-w-[380px]"
    >
      <div className="flex items-center justify-between px-4 pt-2 pb-1 text-[10px] text-white">
        <span className="font-mono">9:41</span>
        <div className="flex items-center gap-1">
          <DemoBadge>DEMO</DemoBadge>
          <span className="font-mono opacity-80">••• 5G ▄▅▇</span>
        </div>
      </div>

      <div className="bg-slate-100 min-h-[520px] max-h-[600px] overflow-y-auto rounded-t-2xl relative">
        <div className="px-3 pt-2 pb-1 text-[11px] text-slate-500 flex items-center justify-between">
          <span className="truncate">{title}</span>
        </div>
        <div className="px-3 pb-4">{children}</div>
      </div>

      <div className="flex items-center justify-between px-4 py-2 bg-slate-900">
        <button
          type="button"
          onClick={onBack}
          disabled={!canBack}
          data-testid="device-back"
          className="inline-flex items-center gap-1 text-[11px] text-white/80 disabled:opacity-30 px-2 py-1"
        >
          <ChevronLeft className="w-3.5 h-3.5" /> Back
        </button>
        <button
          type="button"
          onClick={onHome}
          data-testid="device-home"
          className="p-2 rounded-full bg-white/10 hover:bg-white/20"
          aria-label="Demo home"
        >
          <Home className="w-4 h-4 text-white" />
        </button>
        <div className="w-14" />
      </div>
    </div>
  );
}
